module.exports = __webpack_public_path__ + "media/images/megamenu_competitions_promo-1fb0069d1efa72e2cf548dec8472c217.png";